import { apiExpress, options as defaultHeaders } from '../config';
import { useQueryFetch } from './useQueryFetch';

interface NotifyData {
  success: boolean;
  message: string;
}

interface PostData {
  notify: boolean;
}

export const useVideoViewersNotify = () => {
  const { data, error, loading, fetchData } = useQueryFetch({});
  const { bearerToken } = defaultHeaders;
  const fetch = (videoId: string, recipientId: number, data: PostData) => {
    fetchData({
      url: `/videos/${videoId}/metrics/recipients/${recipientId}`,
      method: 'patch',
      baseURL: apiExpress,
      data: data,
      headers: bearerToken,
    });
  };

  const notifyData: NotifyData = (data && data.data && data.data) || null;

  return { notifyData, loading, error, fetch };
};
